import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container } from '@mui/material';
// sections
import { AppOrderTimeline, AppCurrentVisits, AppWebsiteVisits, AppWidgetSummary } from '../sections/@dashboard/app';
import { getData } from 'src/webService/webService';
import { useEffect, useState } from 'react';
import { convertLength } from '@mui/material/styles/cssUtils';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();
  const sessionToken = sessionStorage.getItem("Token");
  const [leads, setLeads] = useState([]);
  const [allLeads, setAllLeads] = useState([]);


  const getAllLeads = async () => {

    try {
      console.log("Fetching users...");
      console.log("Token being sent:", sessionToken);

      const response = await getData("leads/services", sessionToken);
      console.log("Response:", response)

      const responseData = response.data.results[0]?.paginatedResults;
      const convertedLeads = responseData.filter(lead => lead.generalStatus === "Converted");

      setLeads(convertedLeads);
      setAllLeads(responseData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }

  }

  useEffect(() => {
    getAllLeads();
  }, [])


  return (
    <>
      <Helmet>
        <title> Dashboard </title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Projects" total={leads.length} icon={'carbon:sales-ops'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Leads" total={allLeads.length} color="info" icon={'guidance:auditorium'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Total Sales Team"
              total={allLeads.length}
              color="warning"
              icon={'fluent-mdl2:review-response-solid'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Total Service Team" total={allLeads.length} color="error" icon={'mdi:planet-plus'} />
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <AppWebsiteVisits
              title="Project Tracker"
              subheader="(+43%) than last year"
              chartLabels={[
                '01/01/2003',
                '02/01/2003',
                '03/01/2003',
                '04/01/2003',
                '05/01/2003',
                '06/01/2003',
                '07/01/2003',
                '08/01/2003',
                '09/01/2003',
                '10/01/2003',
                '11/01/2003',
              ]}
              chartData={[
                {
                  name: 'Leads',
                  type: 'column',
                  fill: 'solid',
                  data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                },
                {
                  name: 'Sales Team',
                  type: 'area',
                  fill: 'gradient',
                  data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                },
                {
                  name: 'Service Team',
                  type: 'line',
                  fill: 'solid',
                  data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
                },
                {
                  name: 'Projects',
                  type: 'column',
                  fill: 'solid',
                  data: [14, 25, 36, 30, 45, 35, 63, 52, 59, 36, 39],
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <AppCurrentVisits
              title="Project Reports"
              chartData={[
                { label: 'Pending', value: 4344 },
                { label: 'Inprogress', value: 5435 },
                { label: 'Completed', value: 1443 },
                { label: 'Waiting', value: 4443 },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <AppOrderTimeline
              title="Projects Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  'Content updated',
                  'SEO audit completed',
                  'Website redesign phase 2',
                  'Instagram post shoot completed',
                  'Reel shoot successfully wrapped up',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}